module.exports = __webpack_public_path__ + "img/install-ff.898faf67.gif";